const getCardColor = (ir, eIr) => (!eIr && '#EEE') || (ir < eIr && '#FCF2F3') || '#F8FDF4';

const getDataForPanel = (data, id) => data.find(d => d.panelId === id) || {};

export const projectUtil = {
  getCardColor,
  getDataForPanel
};
